module.exports = __webpack_public_path__ + "img/shuixian2.8e58c9ef.gif";